import { StaticBaseDao } from '@/dao';
import { WeatherResponse } from '@/objects/generated';
import { formatDateIso } from '@/utilities/dateutils';

export class WeatherDao extends StaticBaseDao {
    public static async GetWeatherData(
        latitude: number,
        longitude: number,
        fromUtc: Date | null,
        toUtc: Date | null,
    ): Promise<WeatherResponse | null> {
        return this.BaseFetch(
            WeatherResponse,
            `Weather/GetWeatherData` +
                '?' +
                (latitude == undefined ? '' : `latitude=${latitude}`) +
                '&' +
                (longitude == undefined ? '' : `longitude=${longitude}`) +
                '&' +
                (fromUtc == undefined ? '' : `fromUtc=${fromUtc ? formatDateIso(fromUtc) : null}`) +
                '&' +
                (toUtc == undefined ? '' : `toUtc=${toUtc ? formatDateIso(toUtc) : null}`),
            'GET',
        );
    }
}
